import React from 'react';

function Screenshots() {
  const screenshots = [
    {
      title: 'شاشة الدخول',
      description: 'واجهة احترافية وسهلة',
      image: '/images/app2.png'
    },
    {
      title: 'قائمة المكاتب',
      description: 'تصفح المكاتب العقارية',
      image: '/images/app1.png'
    },
    {
      title: 'الشاشة الرئيسية',
      description: 'تصفح آلاف العقارات المتاحة',
      image: '/images/app3.png'
    },
    {
      title: 'إعلاناتي',
      description: 'تتبع إعلاناتك بسهولة',
      image: '/images/app4.png'
    },
    {
      title: 'تفاصيل العقار',
      description: 'شاهد جميع التفاصيل والصور',
      image: '/images/app5.png'
    }
  ];

  return (
    <section id="screenshots" className="py-20 px-4 sm:px-6 lg:px-8">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-16">
          <h2 className="text-3xl sm:text-4xl font-bold text-awa-dark mb-4">
            تطبيق <span className="text-awa-green">AWA</span> للموبايل
          </h2>
          <p className="text-lg text-awa-gray">
            منصتك العقارية في جيبك - متاح على iOS و Android
          </p>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-6">
          {screenshots.map((screenshot, index) => (
            <div
              key={index}
              className="bg-white rounded-2xl shadow-lg overflow-hidden transform hover:-translate-y-2 transition-all duration-300"
            >
              <div className="aspect-[9/16] bg-gradient-to-br from-awa-green to-awa-green-dark flex items-center justify-center overflow-hidden">
                <img
                  src={screenshot.image}
                  alt={screenshot.title}
                  className="w-full h-full object-contain"
                />
              </div>
              <div className="p-4 text-center">
                <h3 className="text-sm font-bold text-awa-dark mb-1">{screenshot.title}</h3>
                <p className="text-xs text-awa-gray">{screenshot.description}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default Screenshots;
